import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Ностальгический (этнический) туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Вид туризма, который совершается людьми на места своего исторического проживания.</p>
                    <p>Цель этого туризма - посещение родственников, места рождения своего или родителей. Особое
                        значение данный вид туризма имеет для стран, часть населения которых проживает за границей -
                        Польша, Израиль, страны СНГ.</p>
                </div>
            </div>
        </>
    );
}